export const isHallowRedirect = (url: string) => {
  try {
    const hostname = new URL(url, window.location.href).hostname;
    return hostname.endsWith("hallow.com");
  } catch {
    return false;
  }
};
